require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("clojure.walk.js");
goog.provide('clojure.walk');
/**
 * Traverses form, an arbitrary data structure.  inner and outer are
 *   functions.  Applies inner to each element of form, building up a
 *   data structure of the same type, then applies outer to the result.
 *   Recognizes all Clojure data structures. Consumes seqs as with doall.
 */

clojure.walk.walk = function clojure$walk$walk(inner, outer, form) {
  if (cljs.core.list_QMARK_(form)) {
    var G__25003 = cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.list, cljs.core.map.cljs$core$IFn$_invoke$arity$2(inner, form));
    return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(G__25003) : outer.call(null, G__25003);
  } else {
    if (cljs.core.map_entry_QMARK_(form)) {
      var G__25005 = new cljs.core.MapEntry(function () {
        var G__25006 = cljs.core.key(form);
        return inner.cljs$core$IFn$_invoke$arity$1 ? inner.cljs$core$IFn$_invoke$arity$1(G__25006) : inner.call(null, G__25006);
      }(), function () {
        var G__25008 = cljs.core.val(form);
        return inner.cljs$core$IFn$_invoke$arity$1 ? inner.cljs$core$IFn$_invoke$arity$1(G__25008) : inner.call(null, G__25008);
      }(), null);
      return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(G__25005) : outer.call(null, G__25005);
    } else {
      if (cljs.core.seq_QMARK_(form)) {
        var G__25009 = cljs.core.doall.cljs$core$IFn$_invoke$arity$1(cljs.core.map.cljs$core$IFn$_invoke$arity$2(inner, form));
        return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(G__25009) : outer.call(null, G__25009);
      } else {
        if (cljs.core.record_QMARK_(form)) {
          var G__25010 = cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (r, x) {
            return cljs.core.conj.cljs$core$IFn$_invoke$arity$2(r, inner.cljs$core$IFn$_invoke$arity$1 ? inner.cljs$core$IFn$_invoke$arity$1(x) : inner.call(null, x));
          }, form, form);
          return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(G__25010) : outer.call(null, G__25010);
        } else {
          if (cljs.core.coll_QMARK_(form)) {
            var G__25011 = cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.empty(form), cljs.core.map.cljs$core$IFn$_invoke$arity$2(inner, form));
            return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(G__25011) : outer.call(null, G__25011);
          } else {
            return outer.cljs$core$IFn$_invoke$arity$1 ? outer.cljs$core$IFn$_invoke$arity$1(form) : outer.call(null, form);
          }
        }
      }
    }
  }
};
/**
 * Performs a depth-first, post-order traversal of form.  Calls f on
 *   each sub-form, uses f's return value in place of the original.
 *   Recognizes all Clojure data structures. Consumes seqs as with doall.
 */


clojure.walk.postwalk = function clojure$walk$postwalk(f, form) {
  return clojure.walk.walk(cljs.core.partial.cljs$core$IFn$_invoke$arity$2(clojure.walk.postwalk, f), f, form);
};
/**
 * Like postwalk, but does pre-order traversal.
 */


clojure.walk.prewalk = function clojure$walk$prewalk(f, form) {
  return clojure.walk.walk(cljs.core.partial.cljs$core$IFn$_invoke$arity$2(clojure.walk.prewalk, f), cljs.core.identity, f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(form) : f.call(null, form));
};
/**
 * Recursively transforms all map keys from strings to keywords.
 */


clojure.walk.keywordize_keys = function clojure$walk$keywordize_keys(m) {
  var f = function f(p__25014) {
    var vec__25015 = p__25014;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25015, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25015, 1, null);

    if (typeof k === 'string') {
      return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.keyword.cljs$core$IFn$_invoke$arity$1(k), v], null);
    } else {
      return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [k, v], null);
    }
  };

  return clojure.walk.postwalk(function (x) {
    if (cljs.core.map_QMARK_(x)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$2(f, x));
    } else {
      return x;
    }
  }, m);
};
/**
 * Recursively transforms all map keys from keywords to strings.
 */


clojure.walk.stringify_keys = function clojure$walk$stringify_keys(m) {
  var f = function f(p__25018) {
    var vec__25019 = p__25018;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25019, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__25019, 1, null);

    if (k instanceof cljs.core.Keyword) {
      return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.name(k), v], null);
    } else {
      return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [k, v], null);
    }
  };

  return clojure.walk.postwalk(function (x) {
    if (cljs.core.map_QMARK_(x)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$2(f, x));
    } else {
      return x;
    }
  }, m);
};
/**
 * Recursively transforms form by replacing keys in smap with their
 *   values.  Like clojure/replace but works on any data structure.  Does
 *   replacement at the root of the tree first.
 */


clojure.walk.prewalk_replace = function clojure$walk$prewalk_replace(smap, form) {
  return clojure.walk.prewalk(function (x) {
    if (cljs.core.contains_QMARK_(smap, x)) {
      return smap.cljs$core$IFn$_invoke$arity$1 ? smap.cljs$core$IFn$_invoke$arity$1(x) : smap.call(null, x);
    } else {
      return x;
    }
  }, form);
};
/**
 * Recursively transforms form by replacing keys in smap with their
 *   values.  Like clojure/replace but works on any data structure.  Does
 *   replacement at the leaves of the tree first.
 */


clojure.walk.postwalk_replace = function clojure$walk$postwalk_replace(smap, form) {
  return clojure.walk.postwalk(function (x) {
    if (cljs.core.contains_QMARK_(smap, x)) {
      return smap.cljs$core$IFn$_invoke$arity$1 ? smap.cljs$core$IFn$_invoke$arity$1(x) : smap.call(null, x);
    } else {
      return x;
    }
  }, form);
};

Object.defineProperty(module.exports, "walk", {
  enumerable: false,
  get: function get() {
    return clojure.walk.walk;
  }
});
Object.defineProperty(module.exports, "postwalk", {
  enumerable: false,
  get: function get() {
    return clojure.walk.postwalk;
  }
});
Object.defineProperty(module.exports, "prewalk", {
  enumerable: false,
  get: function get() {
    return clojure.walk.prewalk;
  }
});
Object.defineProperty(module.exports, "keywordize_keys", {
  enumerable: false,
  get: function get() {
    return clojure.walk.keywordize_keys;
  }
});
Object.defineProperty(module.exports, "stringify_keys", {
  enumerable: false,
  get: function get() {
    return clojure.walk.stringify_keys;
  }
});
Object.defineProperty(module.exports, "prewalk_replace", {
  enumerable: false,
  get: function get() {
    return clojure.walk.prewalk_replace;
  }
});
Object.defineProperty(module.exports, "postwalk_replace", {
  enumerable: false,
  get: function get() {
    return clojure.walk.postwalk_replace;
  }
});